export const FMI_DATE_FORMAT = 'DD.MM.YYYY';
export const WEEK_DAYS = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
export const FMI_SERVER_DATE_FORMAT = 'YYYY-MM-DD';
export const ACADEMIC_YEAR_DELIMITER = '-';
export const FMI_YEAR_MONTH_FORMAT = 'YYYY-MM';
export const FMI_MONTH_YEAR_FORMAT = 'MM-YYYY';
export const FMI_YEAR_FORMAT = 'YYYY';
export const FMI_FIRST_MONTH_OF_SEMESTER = 4;
export const FMI_CONG_DOAN_SAI_GON_IDS = [1, 2, 7, 9, 10, 19, 20];
